import React, { useState } from "react";
import EnterEmail from "./EnterEmailForm";
import LoginHeader from "../Login/LoginHeader";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ForgotPassword = () => {
  const [isNextPageTriggered, setNextPageTriggered] = useState(false);
  const navigate = useNavigate();
  const { email } = useSelector((state) => state.auth);

  return (
    <div>
      <LoginHeader loginPage={true} />
      {!isNextPageTriggered ? (
        <EnterEmail setNextPageTriggered={setNextPageTriggered} />
      ) : (
        <>
          <div className="flex items-center justify-center min-h-screen bg-white p-4">
            <div className="p-6 max-w-md w-full flex flex-col items-center justify-center">
              {/* Title */}
              <h2
                className="text-center text-2xl font-semibold text-[#1D2739] mb-2"
                style={{ letterSpacing: "0.48px", lineHeight: "normal" }}
              >
                Recovery Link Sent
              </h2>

              {/* Subtitle */}
              <p className="text-center text-base text-gray mb-10">
                {`If an account exists for ${email}, you will get an email
                with instructions on resetting your password. If it doesn’t
                arrive, be sure to check you spam folder.`}
              </p>

              <button
                type="button"
                className={`flex justify-center cursor-pointer items-center self-center w-full sm:w-[432px] h-14 p-5 mt-14
        rounded-[13px] text-center text-base font-medium bg-[#eaf524] text-black`}
                aria-label="Continue to profile"
                onClick={() => navigate("/login")}
              >
                Back to login
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ForgotPassword;
